import { Reveal, ChapterHead } from "./Reveal";
import { useContent } from "@/content";

export const About = () => {
  const c = useContent();

  const DEFAULTS = {
    about_p1: "I am a 16-year-old creative who learned at a young age that the systems you’re placed in can’t be trusted automatically. I learned to question everything in my life, and then I learned to communicate my thoughts and my worldview to the public.",
    about_p2: "I am a Black American, which means I come from a lineage of culture and legacy.",
    about_p3: "My goal in this life is to influence as many people as I can to develop their critical thinking skills, and to embrace their actual humanity — instead of letting society convince them they need to act like a machine just to earn a slight bit of respect.",
    about_p4: "Creators and critical thinking are the future, in a world of expanding technology and inauthenticity becoming the norm.",
  };

  return (
    <section id="about" className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 max-w-7xl mx-auto" data-testid="about-section">
      <ChapterHead index="CHAPTER 01" title="ABOUT" />

      <Reveal>
        <p
          className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-[clamp(2rem,6vw,4.5rem)] max-w-5xl"
          data-testid="about-name-statement"
        >
          {c.about_headline || "My name is Jeremiah Womack."}
        </p>
      </Reveal>

      <div className="mt-12 sm:mt-16 max-w-3xl">
        <div className="space-y-6" data-testid="about-message">
          {["about_p1", "about_p2", "about_p3", "about_p4"].map((k, i) => (
            <Reveal key={k} delay={i * 0.05}>
              <p className="text-base sm:text-lg font-light leading-relaxed text-blue-100/70">
                {c[k] || DEFAULTS[k]}
              </p>
            </Reveal>
          ))}
          <Reveal delay={0.2}>
            <p
              className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight text-white border-l-2 border-[#4F7CFF] pl-5 leading-snug"
              data-testid="about-closer"
            >
              {c.about_closer || "Follow me and my life as I move through these modern times. You are witnessing the beginning of my story."}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
